export default "__VITE_ASSET__Zi9oZFO6__ 1000w";